import { render, staticRenderFns } from "./command_send_history.vue?vue&type=template&id=5af67d8c&scoped=true"
import script from "./command_send_history.vue?vue&type=script&lang=js"
export * from "./command_send_history.vue?vue&type=script&lang=js"
import style0 from "./command_send_history.vue?vue&type=style&index=0&id=5af67d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af67d8c",
  null
  
)

export default component.exports